import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_2 = {
  key: 1,
  class: "fas fa-times"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_button = _resolveComponent("new-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.column.key === 'id')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
      ], 64))
    : (_ctx.column.key === 'fullName')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: `/new-dispatcher/complete-day/${_ctx.row.courierId}?date=${_ctx.row.date}&date_filter=${_ctx.dateFilter}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_button, { class: "NewButton--search" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(_ctx.row.date)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : (_ctx.column.key === 'delivery')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.row.deliveriesDelivered) + "/" + _toDisplayString(_ctx.row.deliveriesTotal), 1)
          ], 64))
        : (_ctx.column.key === 'take')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.row.takesShipped) + "/" + _toDisplayString(_ctx.row.takesTotal), 1)
            ], 64))
          : (_ctx.column.key === 'hour')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.row.timeOfWork), 1)
              ], 64))
            : (_ctx.column.key === 'waves')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(_ctx.row.waves, (wave) => {
                  return (_openBlock(), _createElementBlock("div", { key: wave }, _toDisplayString(wave), 1))
                }), 128))
              : (_ctx.column.key === 'cash')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _createTextVNode(_toDisplayString(_ctx.row.cash) + " ₸ ", 1)
                  ], 64))
                : (_ctx.column.key === 'codPayment')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _createTextVNode(_toDisplayString(_ctx.row.codPayment) + " ₸ ", 1)
                    ], 64))
                  : (_ctx.column.key === 'hasReturnDelivery')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        (_ctx.row.hasReturnDelivery)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_1))
                          : (_openBlock(), _createElementBlock("i", _hoisted_2))
                      ], 64))
                    : (_ctx.column.key === 'isClosed')
                      ? (_openBlock(), _createBlock(_component_new_button, {
                          key: 9,
                          class: "NewButton--small NewButton--outline",
                          disabled: _ctx.row.isClosed || _ctx.state.is_loading,
                          loading: _ctx.state.is_loading,
                          onClick: _ctx.closeDay
                        }, {
                          default: _withCtx(() => [
                            (_ctx.row.isClosed)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Завершен")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Завершить")
                                ], 64))
                          ]),
                          _: 1
                        }, 8, ["disabled", "loading", "onClick"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                          _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
                        ], 64))
}